import { Button, Card, Col, Result, Row } from "antd";
import React, { useEffect } from "react";

export default function LoginFailed() {
  return (
    <Card
      style={{
        height: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Result
          status="error"
          title="Login Failed"
          subTitle="You are not authorized to access this admin panel. Please contact the administrator."
          extra={[
            <Button
              type="primary"
              key="retry"
              onClick={() => {
                window.location.href = "/login";
              }}
            >
              Try Again
            </Button>,
          ]}
        />
      </div>
    </Card>
  );
}
